module.exports = __webpack_public_path__ + "static/media/bell.6a1318a2.png";